module.exports = __webpack_public_path__ + "static/i-know-why-the-caged-bird-sings-a8134ceb4c654af5cfa2ad49958f9f9e.jpg";